import * as React from 'react';
import { classes, st } from './image-component-wut.st.css';
import { Image as ImageWUT, ImageLoadingBehaviorOptions, ImageResizeOptions } from '@wix/wix-ui-tpa/cssVars';
import { ImageAlignment, ImageFit } from '../../types/image';
const getResize = imageResize => {
  switch (imageResize) {
    case 'contain':
      return ImageResizeOptions.contain;
    case 'cover':
      return ImageResizeOptions.cover;
  }
  return undefined;
};
export function ImageComponentWUT(props) {
  const {
    imageResize = ImageFit.COVER,
    imageAlignment = ImageAlignment.CENTER
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.imageContainer, {
      imageAlignment,
      imageResize
    }),
    style: {
      aspectRatio: props.aspectRatio ? String(props.aspectRatio) : undefined
    }
  }, props.image ? /*#__PURE__*/React.createElement(ImageWUT, {
    alt: props.alt,
    key: props.image.id,
    resize: getResize(imageResize),
    src: props.image.id,
    loadingBehavior: ImageLoadingBehaviorOptions.spinner
  }) : null);
}
//# sourceMappingURL=image-component-wut.js.map